module.exports = __webpack_public_path__ + "static/media/IMG_7835.07428e89.JPG";